module.exports = __webpack_public_path__ + "img/primo-fruits-desktop_640x964.dd8ad5a6.jpg";